/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    addBtn: {
        tooltip: "Add to list"
    },
    deleteBtn: {
        tooltip: "Delete item"
    },
    emptyContainer: "No items"
};